const SET_UNLEASH = (state, { name, data }) => {
  state.unleash[name] = data;
};

export default SET_UNLEASH;
